import OpenCall from '../components/OpenCall';
import PageLayout from '../components/pageLayout';

function OpenCallPage() {
    return (
        <PageLayout children={<OpenCall />} />
    );
}

export default OpenCallPage;
